import React from "react";

export function UserRolesAddUsers() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-800">Add Users</h2>
        <p className="text-sm text-muted-foreground">
          Add users content will be added here.
        </p>
      </div>
    </div>
  );
}
